import { makeAutoObservable, runInAction } from "mobx"
import {
  ActionError,
  ActionResultStatus,
  ActionSuccess,
  QueryResponse,
} from "types/Global"
import { resultOrError } from "../../../utils/Global"
import { call } from "../../CloudAPI"

class CounterfeitReportStore {
  // lists
  loadingCounterfeitReportResponse = false
  counterfeitReportResponse = null

  // init function
  constructor() {
    makeAutoObservable(this)
  }

  // actions
  async sendReportEmail(
    email: string,
    firstName: string,
    lastName: string,
    companyName: string,
    street: string,
    postalCode: string,
    city: string,
    country: string,
    code: string,
    placeOfPurchase: string,
    dateOfPurchase: string,
    manufacturer: string,
    description: string,
    photos: string[],
    pdf: string[]
  ) {
    this.loadingCounterfeitReportResponse = true

    const body = {
      email,
      firstName,
      lastName,
      companyName,
      street,
      postalCode,
      city,
      country,
      code,
      placeOfPurchase,
      dateOfPurchase,
      manufacturer,
      description,
      photos,
      pdf,
    }

    const [result, error]: any  = await resultOrError<QueryResponse<any>>(
      call(
        "CounterfeitReport",
        {
          ...body,
        },
        "BrandOSMaster",
        process.env.REACT_APP_API_AUTH_CHECK_USERNAME,
        process.env.REACT_APP_API_AUTH_CHECK_PASSWORD
      )
    )

    if (result) {
      runInAction(() => {
        this.counterfeitReportResponse = result
        this.loadingCounterfeitReportResponse = false
      })
      return {
        status: ActionResultStatus.SUCCESS,
        result: result,
      } as ActionSuccess<number>
    } else {
      runInAction(() => {
        this.loadingCounterfeitReportResponse = false
      })
      return {
        status: ActionResultStatus.ERROR,
        error: error,
      } as ActionError
    }
  }
}

export default CounterfeitReportStore
